export default "/WebApp/dist/assets/svg/otherFile.svg";